import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Form, FormResult } from '../../../../components/Form';
import { AuthContext } from '../../../../components/FirebaseAuth';
import UserPageLayout from '../../../../components/user/UserPageLayout';

const VerifyEmail = () => {
    const { t } = useTranslation();
    const backToUrl = "/user/profile";
    const navigate = useNavigate();
    const mountedRef = useRef(true);

    const { authUser } = useContext(AuthContext);

    const [result, setResult] = useState({
        status: null,
        message: ''
    });

    const [inSubmit, setInSubmit] = useState(false);

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);

    return (
        <UserPageLayout title={t('verifyEmail.title')} >
            { result.status === null && !authUser.user.emailVerified &&
                <Form handleSubmit={e => {
                    e.preventDefault();
                    setInSubmit(true);
                    authUser.user.sendEmailVerification().then(() => {
                        if (!mountedRef.current) return null
                        setResult({
                            status: true,
                            message: t('verifyEmail.successMessage')
                        });
                        setInSubmit(false);
                    }).catch((err) => {
                        if (!mountedRef.current) return null
                        setResult({
                            status: false,
                            message: err.message
                        });
                        setInSubmit(false);
                    })
                }}
                disabled={inSubmit}
                inSubmit={inSubmit}
                enableDefaultButtons={true}
                backToUrl="/user/profile"
                >
                    <div style={{marginTop: '20px', marginBottom: '20px'}}>
                        {t('verifyEmail.sendPrompt')} <strong>{authUser.user.email}</strong>
                    </div>
                </Form>
            }
            { result.status === null && authUser.user.emailVerified &&
                <FormResult
                    severity="success"
                    resultMessage={t('verifyEmail.alreadyVerified')}
                    primaryText={t('common.viewProfile')}
                    primaryAction={() => {
                        navigate(backToUrl);
                    }}
                />
            }
            { result.status === false &&
                <FormResult
                    severity="error"
                    resultMessage={result.message}
                    primaryText={t('common.tryAgain')}
                    primaryAction={() => {
                        setResult({
                            status: null,
                            message: ''
                        })
                    }}
                    secondaryText={t('common.viewProfile')}
                    secondaryAction={() => {
                        navigate(backToUrl);
                    }}
                />
            }
            { result.status === true &&
                <FormResult
                    severity="success"
                    resultMessage={result.message}
                    primaryText={t('common.viewProfile')}
                    primaryAction={() => {
                        window.location.href=backToUrl;
                    }}
                />
            }
        </UserPageLayout>
    )
}

export default VerifyEmail;
